import * as moment from 'moment-timezone';
import { Sorting } from '../models/models';

export class Utils {
  static combineURLs(urls: string[]): string {
    return urls.join('/').replace(new RegExp('([^:]\\/)\\/+', 'g'), '$1');
  }

  public static formatPrice(price: number): string {
    return price.toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  public static dateAgo(date: string) {
    let time = 'Il y a ';
    let diff = moment().diff(moment(date), 'days');
    if (diff > 0) {
      time += 'plus de 24h';
      return time;
    }
    diff = moment().diff(moment(date), 'hours');
    if (diff > 0) {
      time += diff + 'h';
      return time;
    }
    diff = moment().diff(moment(date), 'minutes');
    if (diff > 0) {
      time += diff + 'm';
      return time;
    }
    diff = moment().diff(moment(date), 'seconds');
    if (diff > 0) {
      time += diff + 's';
      return time;
    }
    return time;
  }

  public static clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  public static fileToBase64(file) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      }
      reader.readAsDataURL(file);
    });
  }

  public static sort(entries: any[], sorting: Sorting) {
    if (!entries) { return null; }
    const sortBy = sorting.sortBy.split(':');
    if (sortBy.length > 1) {
      return entries.sort((a,b) => (a[sortBy[0]][sortBy[1]] > b[sortBy[0]][sortBy[1]]) ? (sorting.sortDirection === 'ASC' ? 1 : -1) : ((b[sortBy[0]][sortBy[1]] > a[sortBy[0]][sortBy[1]]) ? (sorting.sortDirection === 'ASC' ? -1 : 1) : 0));
    } else {
      if (sortBy[0] === 'startDate') {
        return entries.sort((a,b) => (moment(a[sortBy[0]]).isAfter(b[sortBy[0]])) ? (sorting.sortDirection === 'ASC' ? 1 : -1) : (moment(b[sortBy[0]]).isAfter(a[sortBy[0]]) ? (sorting.sortDirection === 'ASC' ? -1 : 1) : 0));
      }
      return entries.sort((a,b) => (a[sortBy[0]] > b[sortBy[0]]) ? (sorting.sortDirection === 'ASC' ? 1 : -1) : ((b[sortBy[0]] > a[sortBy[0]]) ? (sorting.sortDirection === 'ASC' ? -1 : 1) : 0));
    }
  }

  public static isEmpty(value) {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }

  public static copy(obj: any) {
    return JSON.parse(JSON.stringify(obj))
  }
  
}
